import { ReactNode } from "react";
import cx from "classnames";
import camelCase from "lodash-es/camelCase";

import { IconComponent } from "types/Icon";

import styles from "./styles.module.css";
import { IconEmphasizedColor } from "./types";
import Box from "../Box";
import Icon from "../Icon";

type IconEmphasizedProps = (
  | {
      icon: IconComponent;
      children?: ReactNode;
    }
  | {
      icon?: IconComponent;
      children: ReactNode;
    }
) & {
  color?: IconEmphasizedColor;
  className?: string;
};

const IconEmphasized = ({ color = "gray", icon, children, className }: IconEmphasizedProps) => {
  return (
    <Box
      align="center"
      justify="center"
      shrink="0"
      className={cx(styles.iconTile, styles[camelCase(color)], className)}
    >
      {icon ? <Icon src={icon} /> : children}
    </Box>
  );
};

IconEmphasized.displayName = "DS.IconEmphasized";

export default IconEmphasized;
